import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
// css
import '../../styles/global.css';
import './AtualizarCheckinQrCodeMesa.css';
// api
import { atualizarDadosCheckinComQrCodeMesa, fazerCheckout } from '../../services/api';
// cookies
import Cookies from 'js-cookie';


const AtualizarCheckinQrCodeMesa = () => {
  const navigate = useNavigate();
  
  // Pega os dados da sessão diretamente
  const userData = JSON.parse(sessionStorage.getItem('userData')); // Assume que os dados estão armazenados no sessionStorage
  // const statusUsuario = userData?.statusUsuario;
  // const nomePerfil = userData?.dadosPerfil?.nome;
  // const nomeUsuario = userData?.user.name;

  const [isAuthorized, setIsAuthorized] = useState(true);

  // vamos pegar o dadosCheckin dos cookies
  // const dadosCheckin = JSON.parse(sessionStorage.getItem('dadosCheckin')) || {};
  // const dadosCheckin = JSON.parse(Cookies.get('dadosCheckin')) || {};

  // da forma antiga de pegar o dadosCheckin estava dando erro.
  const cookieStr = Cookies.get('dadosCheckin');
  let dadosCheckin = {};  
  if (cookieStr) {
    try {
      dadosCheckin = JSON.parse(cookieStr);
    } catch (error) {
      console.error('Falha ao decodificar JSON do cookie:', cookieStr, error);
    }
  } else {
    console.warn('Cookie "dadosCheckin" não encontrado');
  }

  const { numeroMesa, idEstabelecimento} = useParams();


  useEffect(() => {
    console.log('--- Entrou em AtualizarCheckinQrCodeMesa ---');
    console.log('id do estabelecimento:', idEstabelecimento);
    console.log('Dados do checkin:', dadosCheckin);
  
    verificarDadosCheckin();

  }, [idEstabelecimento, dadosCheckin]);
  


  const verificarDadosCheckin = () => {

    // handleCheckout();

      // verificar se tem dadosCheckin - se o checkin já foi feito
      if (Object.keys(dadosCheckin).length === 0) {

        /**
         * O checkin ainda não foi feito.
         * Vamos fazer o checkin para o usuário, a partir do qr-code
         */
        console.log('Usuário ainda não fez checkin. Vamos redirecioná-lo para o checkin por qr code');
        navigate(`/fazer-checkin-por-qrcode/${numeroMesa}/${idEstabelecimento}`);

      } else {
        // aqui quer dizer que tem dadosCheckin na sessão. Vamos confirmar se o usuário fez checkin
        console.log('dadosCheckin');
        console.log(dadosCheckin);

        // return;
        
        if( dadosCheckin.statusCheckin === 'usuarioCheckado' ){
          /**
           * aqui quer dizer que temos dados do checkin.
           * vamos fazer a atualização
           */
          handleAtualizarDadosCheckinComQrCodeMesa();
          navigate('/usuario-checkado', { dadosCheckin: { dadosCheckin } });
        }
      }
  }


  // Função para fazer o logout - checkout
  const handleCheckout = async (e) => {
      e.preventDefault();
      console.log('---- ENTROU NO HANDLE CHECKOUT ----');
      console.log('Fazendo Checkout... dadosCheckin:');
      console.log(dadosCheckin);
      try {   
        const response = await fazerCheckout(dadosCheckin);
        const message = response.message;
        console.log('--------------------------------');
        console.log('Usuário fez checkout com sucesso!');
        console.log('Dados Checkout: ', response);
        console.log('--------------------------------');
          // Remove os dados da sessão
          sessionStorage.removeItem('dadosCheckin');
          // remove cookies
          Cookies.remove('dadosCheckin');

        alert(message);

        navigate('/');
        
      } catch (error) {
        console.error('Erro ao fazer check-out:', error);
        const errorMessage = error.response?.data?.message ?? 'Erro ao fazer check-out. Tente novamente.';

        alert(errorMessage);
      }
  };



  const handleAtualizarDadosCheckinComQrCodeMesa = async (e) =>{
    // e.preventDefault();
    console.log('Entrou em atualizar dados do checkin com QR Code da mesa!');
    
    console.log('número da mesa: ');
    console.log(numeroMesa);

    console.log('Chamando método da api para atualizar...');
    try {   
      const response = await atualizarDadosCheckinComQrCodeMesa(dadosCheckin, numeroMesa);
      const message = response.message;
      // const nomeEstabelecimento = response.nomeEstabelecimento;

      // vamos atualizar os dados do checkin dos cookies
      atualizarDadosCheckinCookies();
      console.log('--------------------------------');
      console.log('Dados do checkin com a mesa atualizados com sucesso!');
      console.log('--------------------------------');
      
      alert(message);

      navigate('/');
      
    } catch (error) {
      console.error('Erro ao atualizar os dados do QR Code da mesa:', error);
      const errorMessage = error.response?.data?.message ?? 'Erro ao atualizar os dados. Tente novamente.';

      alert(errorMessage);
    }

  }

  const atualizarDadosCheckinCookies = () => {
    console.log('Entrou em atualizarDadosCheckinCookies....');
    
    const dadosCheckinStr = Cookies.get('dadosCheckin');
  
    if (!dadosCheckinStr) {
      console.error('Cookie dadosCheckin não encontrado.');
      return;
    }
  
    try {
      const dadosObj = JSON.parse(dadosCheckinStr);
      
      if (dadosObj.objBarcheckin) {

        // vamos atualizar tanto a informação em barcheckin, quando fora, em numeroMesa
        dadosObj.objBarcheckin.numero_mesa = numeroMesa;
        dadosObj.numeroMesa = numeroMesa;
  
        Cookies.set('dadosCheckin', JSON.stringify(dadosObj));
        console.log('ok, dados atualizados');
      } else {
        console.error('objBarcheckin não encontrado em dadosCheckin.');
      }
    } catch (error) {
      console.error('Erro ao fazer parse do cookie dadosCheckin:', dadosCheckinStr);
    }
  };
  





  return (
    <div autoFocus className="bar-gerente-container">
        <TituloComponent />
        <h1 className="sub-titulo">Atualização do Checkin</h1>

    </div>
  );
};

export default AtualizarCheckinQrCodeMesa;
